import React, { useState, useMemo, useEffect } from 'react';
import Select from 'react-select';
// import { faEdit, faTrash, faInfoCircle  } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip'; // Use the named export
import 'react-tooltip/dist/react-tooltip.css'; // Import the CSS for styling
import { useTable, useSortBy, usePagination } from 'react-table';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEllipsisV, faTrash, faUser, faInfoCircle, faSyncAlt, faEye, faChevronCircleLeft, faPencil, faPlus } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import imageCompression from 'browser-image-compression';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalFilter } from 'react-table'; // ✅ Import this
import moment from 'moment';

// import 'sweetalert2/src/sweetalert2.scss';

const SewadarList = ({ permissions }) => {
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [sewadars, setSewadars] = useState([]);
  const [editSewadarId, setEditSewadarId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const centerCode = localStorage.getItem('code');
  const role = localStorage.getItem('role');
  const token = localStorage.getItem('token');
  const [loadingData, setLoadingData] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [position, setPosition] = useState("");
  const departmentOptions = useMemo(() => {
    const depts = sewadars.map(s => s.sewadarOf).filter(Boolean);
    return [...new Set(depts)];
  }, [sewadars]);


  const navigate = useNavigate(); // Initialize useNavigate
  useEffect(() => {
    fetchSewadars();
  }, [centerCode]); // Re-fetch departments when centerCode changes

  const handleToggleStatus = async (email, currentStatus) => {
    const newStatus = currentStatus == 1 ? 0 : 1;
    const displayStatus = newStatus == 1 ? 'Active' : 'Inactive';

    // Ask for confirmation first
    const confirmResult = await Swal.fire({
      title: `Are you sure?`,
      text: `You are about to change the status to ${displayStatus}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'Cancel'
    });

    if (!confirmResult.isConfirmed) return;

    try {
      const response = await apiClient.post(`${SERVER_BASE}/update-status`, {
        email,
        status: newStatus
      });

      Swal.fire({
        title: `Status updated to ${displayStatus}`,
        toast: true,
        position: 'top-end',
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        icon: 'success'
      }).then(() => {
        fetchSewadars()
      });

      // Optionally refresh data here
    } catch (error) {
      const message = error.response?.data?.message || "Failed to update status";
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message
      });
    }
  };
  const fetchSewadars = async () => {
    try {
      setLoadingData(true); // start loading
      const response = await apiClient.get(SERVER_BASE + '/getSewadar', {
        params: { code: centerCode },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSewadars(response.data);
    } catch (error) {
      console.error('Error fetching Sewadars:', error);
    } finally {
      setLoadingData(false); // stop loading
    }
  };
  const handleDelete = async (row) => {
    const { id, email, code, username } = row; // Destructure necessary fields from row.original

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('Unauthorized: No token found.');
      Swal.fire({
        icon: 'error',
        text: 'You need to log in to perform this action.',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this Sewadar? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (confirmation.isConfirmed) {
      try {
        // Send delete request with JWT token in headers
        await apiClient.delete(SERVER_BASE + '/deleteSewadar', {
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
          data: { sewadarId: id, email, code: centerCode, username }, // Data for the request body
        });

        setSewadars((prev) => prev.filter((sewadar) => sewadar.id !== id));

        Swal.fire({
          icon: 'success',
          title: 'Sewadar deleted successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error deleting Sewadar:', error);

        Swal.fire({
          icon: 'error',
          title: 'An error occurred while deleting the Sewadar.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };

  const handleEdit = (row) => {
    navigate(`../sewadar`, { state: { row } });

  };
  const handleView = (row) => {
    navigate(`../sewadar`, { state: { row } });

  };

  const handlePermissions = (row) => {
    navigate('../permissions', { state: { rowData: row } });
  }

  const columns = useMemo(() => [
    {
      Header: 'S.No',
      Cell: ({ row }) => row.index + 1,
    },
    { Header: 'BadgeID', accessor: 'badgeId' },
    // { Header: 'ZonalID', accessor: 'zonalBadgeId' },
    { Header: 'Name', accessor: (row) => `${row.firstName} ${row.lastName}` },
    { Header: 'Department', accessor: 'sewadarOf' },
    { Header: 'Position', accessor: 'position' },
    { Header: 'Contact No', accessor: 'contactNo' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Status', accessor: (row) => `${row.isActive == 1 ? 'Active' : 'Inactive'}` },
    {
      Header: "#",
      accessor: "actions",
      Cell: ({ row }) => {
        const {
          created_at,
          createdByName,
          updatedAt,
          updatedByName,
        } = row.original;
        return (
          <div className="dropdown">
            <button
              className="btn btn-light"
              type="button"
              id={`dropdownMenuButton-${row.index}`}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby={`dropdownMenuButton-${row.index}`}
            >
              {(role == 'itManager' || permissions?.edit) && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleEdit(row.original)}
                  >
                    <FontAwesomeIcon icon={faEdit} /> Edit
                  </button>
                </li>
              )}

              {(role == 'itManager' || permissions?.delete) && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleDelete(row.original)}
                  >
                    <FontAwesomeIcon icon={faTrash} /> Delete
                  </button>
                </li>
              )}
              {(role == 'itManager' || role == 'Authorized Person' || role == 'Main Incharge') && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handlePermissions(row.original)}
                  >
                    <FontAwesomeIcon icon={faUser} /> Permissions
                  </button>
                </li>
              )}
              {(role === 'itManager' || role === 'Authorized Person') && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleToggleStatus(row.original.email, row.original.isActive)}
                  >
                    <FontAwesomeIcon icon={faSyncAlt} /> Set&nbsp;
                    {row.original.isActive == '1' ? 'Inactive' : 'Active'}
                  </button>
                </li>
              )}
              {(createdByName || updatedByName) && (
                <li>
                  <hr className="dropdown-divider" />
                </li>
              )}
              {createdByName && (
                <li className="dropdown-item">
                  <FontAwesomeIcon icon={faPlus} /> {createdByName}
                  {created_at &&
                    ` (${moment(created_at).format("DD-MMM-YY hh:mm A")})`}
                </li>
              )}

              {/* Updated Info */}
              {updatedByName && (
                <li className="dropdown-item">
                  <FontAwesomeIcon icon={faPencil} /> {updatedByName}
                  {updatedAt &&
                    ` (${moment(updatedAt).format("DD-MMM-YY hh:mm A")})`}
                </li>
              )}
            </ul>
          </div>
        )
      },
    },
  ], [permissions]);


  // const filteredData = useMemo(() => {
  //   return sewadars.filter((sewad) => {
  //     const fullName = `${sewad.firstName} ${sewad.lastName}`.toLowerCase();

  //     const matchesSearch =
  //       !searchTerm || fullName.includes(searchTerm.toLowerCase());

  //     const matchesDepartment =
  //       !selectedDepartment || sewad.sewadarOf === selectedDepartment;

  //     const matchesStatus =
  //       selectedStatus === ''
  //         ? true
  //         : selectedStatus === 'active'
  //         ? sewad.isActive == 1
  //         : sewad.isActive == 0;

  //     return matchesSearch && matchesDepartment && matchesStatus;
  //   });
  // }, [sewadars, searchTerm, selectedDepartment, selectedStatus]);

  // Use the useTable hook with sorting and pagination
  const filteredData = useMemo(() => {
    const search = searchTerm.toLowerCase();

    return sewadars.filter((sewad) => {
      const fullName = `${sewad.firstName || ''} ${sewad.lastName || ''}`.toLowerCase();

      const matchesSearch =
        !search ||
        fullName.includes(search) ||
        sewad.badgeId?.toLowerCase().includes(search) ||
        sewad.email?.toLowerCase().includes(search) ||
        sewad.sewadarOf?.toLowerCase().includes(search) ||
        sewad.position?.toLowerCase().includes(search);

      const matchesDepartment =
        !selectedDepartment || sewad.sewadarOf === selectedDepartment;
        const matchesPosition =
        !position || sewad.position === position;

      const matchesStatus =
        selectedStatus === ''
          ? true
          : selectedStatus === 'active'
            ? sewad.isActive == 1
            : sewad.isActive == 0;

      return matchesSearch && matchesDepartment && matchesStatus && matchesPosition;
    });
  }, [sewadars, searchTerm, selectedDepartment, selectedStatus, position]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: filteredData,
      initialState: {
        pageIndex: parseInt(localStorage.getItem('currentPageIndex')) || 0,
        pageSize: 100,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );



  useEffect(() => {
    localStorage.setItem('currentPageIndex', pageIndex);
  }, [pageIndex])

  if (loadingData) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Loading Sewadar List...</div>
      </div>
    );
  }

  return (
    <div className="mt-5">
      {/* Search Input */}
      {(role == 'itManager' || permissions?.read || permissions?.edit || permissions?.delete) && (
        <div className="formcontainer">
          <div className="d-flex justify-content-between align-items-center">
            <h3>Sewadar</h3>
            <div className="ledger-count">
              Total Sewadar: <strong>{filteredData.length}</strong>
            </div>

          </div>
          <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
            {/* Add Sewadar Button */}
            <button
              className="btn btn-outline-success"
              onClick={() => navigate('../sewadar')}
              style={{ whiteSpace: 'nowrap' }}
            >
              Add Sewadar
            </button>

            {/* Search */}
            <input
              type="text"
              className="form-control"
              style={{ width: "35%" }}
              placeholder="Search name"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                gotoPage(0);
              }}
            />

            {/* Department Filter */}
            <select
              className="form-select"
              style={{ width: "17%" }}
              value={selectedDepartment}
              onChange={(e) => {
                setSelectedDepartment(e.target.value);
                gotoPage(0);
              }}
            >
              <option value="">All Departments</option>
              {departmentOptions.map((dept) => (
                <option key={dept} value={dept}>
                  {dept}
                </option>
              ))}
            </select>
            <select
              className="form-select"
              value={position}
              style={{ width: "17%" }}
              onChange={(e) => {
                setPosition(e.target.value)
                gotoPage(0)
              }
              }
            > <option value="">All</option>
              <option value="Sewadar">Sewadar</option>
              <option value="Approver">Approver</option>
              <option value="Authorized Person">Authorized Person</option>
              <option value="Main Incharge">Main Incharge</option>
            </select>
            {/* Status Filter */}
            <select
              className="form-select"
              style={{ width: "10%" }}
              value={selectedStatus}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                gotoPage(0);
              }}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>

            {/* Page Size */}
            <select
              className="form-select w-auto"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 25, 50, 100, 200].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>

          </div>


          <div className=''>
            <table className="table table-bordered table-striped mt-1" {...getTableProps()} style={{ fontSize: '15px', verticalAlign: 'baseline' }}>
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps(column.getSortByToggleProps())} key={column.id}>
                        {column.render('Header')}
                        {/* Add sort indicator */}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? ' 🔽' // Descending sort
                              : ' 🔼' // Ascending sort
                            : ''}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>

            </table>
          </div>

          {/* Updated Pagination Section */}
          <div className="d-flex justify-content-between">
            <button className="btn btn-secondary" onClick={previousPage} disabled={!canPreviousPage}>
              <FontAwesomeIcon icon={faChevronCircleLeft}></FontAwesomeIcon> Previous
            </button>
            <span>  Page {pageIndex + 1} of {pageOptions.length}</span>

            <button className="btn btn-secondary" onClick={nextPage} disabled={!canNextPage}>
              Next <FontAwesomeIcon icon={faChevronCircleLeft} rotation={180}></FontAwesomeIcon>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SewadarList;
